import React from 'react';
import { Grid , CircularProgress } from '@material-ui/core';
export default () =>(
  <Grid container style={{ height:'calc(100vh - 116px)', alignItems:"center" }}>
    <Grid item xs={12}>
      <CircularProgress />
    </Grid>
  </Grid>
)